module.exports = __webpack_public_path__ + "static/media/E3.5d5f3c50.jpeg";